// And underscore (_) represenstts a forward slash (/) or hyphen (-)
type AuthRouteKey = '_home'
type AuthRoutesMap = { [key in AuthRouteKey]: string }

export const AUTH_PAGE_ROUTES: AuthRoutesMap = {
  _home: '/',
}
